import { FOOTER_REQUEST, FOOTER_SUCCESS, FOOTER_FAIL } from "../actions/footerActions";
const initialState = { loading: false, data: null, error: null };
export default function footerReducer(state = initialState, action) {
  switch (action.type) {
    case FOOTER_REQUEST: return { loading: true, data: null, error: null };
    case FOOTER_SUCCESS: return { loading: false, data: action.payload, error: null };
    case FOOTER_FAIL: return { loading: false, data: null, error: action.payload };
    default: return state;
  }
}
